/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ConfigurazioneFormTranslatedDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetTipoPraticaConfigurazioneFormEsercenteTranslatedRequestParams {
    idTipoPratica: string;
}


export interface TipoPraticaConfigurazioneFormEsercenteTradottoOperatoreServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Ritorna il template del form esercente del bando già tradotto dal resolver ($dynamic espanso). Read-only, audience SUPERADMIN | OP_COMUNE | OP_PRATICA_ESERCENTE.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/configurazione-form-esercente-translated
* @param requestParameters
     */
    getTipoPraticaConfigurazioneFormEsercenteTranslated(requestParameters: GetTipoPraticaConfigurazioneFormEsercenteTranslatedRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneFormTranslatedDTO>;

}
